<template>
    <div>
        This is the trade in page
    </div>
</template>